import dayjs from 'dayjs';
import Text from '../../../components/detail/components/Text.component';
import RectangleChip from '../../../components/common/RectangleChip.component';
import { Box } from '@mui/material';

const PRIORITY_COLORS = {
  URGENT: '#d32f2f',
  MEDIUM: '#f5b400',
  LOW: '#388e3c',
};

const STATUS_COLORS = {
  OPEN: '#d32f2f',
  CLOSED: '#388e3c',
};

export const DetailConf = {
  initialState: {
    data: {},
    loading: false,
    error: null,
  },
  fields: [
    {
      id: 'ticket_information_section',
      type: 'section',
      label: 'Ticket Information',
      xs: 12,
      items: [
        {
          type: 'text',
          label: 'Type',
          key: 'attributes.type',
          xs: 12,
        },
        {
          type: 'text',
          label: 'Yacht',
          key: 'attributes.yacht_name',
          xs: 12,
          sm: 6,
        },
        {
          type: 'text',
          label: 'Priority',
          key: 'attributes.priority',
          xs: 12,
          sm: 3,
        },
        {
          type: 'text',
          label: 'Status',
          key: 'attributes.status',
          xs: 12,
          sm: 3,
        },
        {
          type: 'text',
          label: 'Department',
          key: 'attributes.department',
          xs: 12,
          sm: 6,
        },
        {
          type: 'text',
          label: 'Team',
          key: 'attributes.team',
          xs: 12,
          sm: 3,
        },
        {
          type: 'text',
          label: 'Assignee',
          key: 'attributes.assignee_user',
          xs: 12,
          sm: 3,
        },
        {
          type: 'text',
          label: 'Date',
          key: 'attributes.date',
          xs: 12,
          sm: 6,
        },
        {
          type: 'text',
          label: 'Title',
          key: 'attributes.title',
          xs: 12,
          sm: 12,
        },
        {
          type: 'text',
          label: 'Description',
          key: 'attributes.description',
          xs: 12,
          sm: 12,
        },
        {
          type: 'text',
          label: 'Created',
          key: 'attributes.createdAt',
          xs: 12,
          sm: 6,
        },
        {
          type: 'text',
          label: 'Created by',
          key: 'attributes.created_by_user',
          xs: 12,
          sm: 3,
        },
        {
          type: 'text',
          label: 'Closed by',
          key: 'attributes.closed_by_user',
          xs: 12,
          sm: 3,
        },
      ],
    },
  ],
  formatValue: (key, value) => {
    switch (key) {
      case 'attributes.type':
        return value ? (
          <Box sx={{ mb: 1 }}>
            <RectangleChip
              value={value.toUpperCase()}
              backgroundColor='#009ab6'
              color='#fff'
              width='auto'
            />
          </Box>
        ) : (
          <Text label='Type' value='-' />
        );

      case 'attributes.priority':
        return value ? (
          <Box sx={{ mb: 1 }}>
            <RectangleChip
              value={value}
              backgroundColor={PRIORITY_COLORS[value] || '#757575'}
              color='white'
              width='auto'
            />
          </Box>
        ) : (
          <Text label='Priority' value='-' />
        );

      case 'attributes.status':
        return value ? (
          <Box sx={{ mb: 1 }}>
            <RectangleChip
              value={value}
              backgroundColor={STATUS_COLORS[value] || '#757575'}
              color='white'
              width='auto'
            />
          </Box>
        ) : (
          <Text label='Status' value='-' />
        );

      case 'attributes.createdAt':
        return (
          <Text
            label='Created'
            value={value ? dayjs(value).format('DD/MM/YYYY HH:mm') : '-'}
          />
        );

      case 'attributes.updatedAt':
        return (
          <Text
            label='Updated'
            value={value ? dayjs(value).format('DD/MM/YYYY HH:mm') : '-'}
          />
        );

      case 'attributes.date':
        return (
          <Text
            label='Date'
            value={value ? dayjs(value).format('DD/MM/YYYY') : '-'}
          />
        );

      default:
        return null;
    }
  },
};